import { Component, OnInit, Input } from '@angular/core';
import { CNDoctor } from 'src/app/models/cndoctor';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime, tap, switchMap, finalize } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { DoctorService } from 'src/app/services/doctor.service';

@Component({
  selector: 'app-doctor-selection',
  templateUrl: './doctor-selection.component.html',
  styleUrls: ['./doctor-selection.component.scss']
})
export class DoctorSelectionComponent implements OnInit {

  @Input() label = 'Médecin Référence';

  selectedDoctor: CNDoctor;

  searchDoctorsCtrl = new UntypedFormControl();
  filteredDoctors: CNDoctor[];
  isLoading = false;
  errorMsg: string;

  public description: string;

  constructor(private doctorService: DoctorService) { }

  ngOnInit(): void {
    this.searchDoctorsCtrl.valueChanges
      .pipe(
        debounceTime(500),
        tap(() => {
          this.errorMsg = '';
          this.filteredDoctors = [];
          this.isLoading = true;
        }),
        switchMap(value => this.doctorService.search(value)
          .pipe(
            finalize(() => {
              this.isLoading = false;
            }),
          )
        )
      )
      .subscribe(doctors => {
        this.filteredDoctors = doctors;
        this.isLoading = false;
      });
  }

  @Input() set doctor(adoctor: CNDoctor) {
    this.selectedDoctor = adoctor;
    if (this.selectedDoctor) {
      this.description = this.selectedDoctor.firstname + ' ' + this.selectedDoctor.lastname;
    }
  }

}
